import 'isomorphic-fetch';
import { isString, isArray, isFunction, keys } from 'lodash';

const symbols = {
  dom: Symbol('dom urls map property'),
  presets: Symbol('presets urls map property'),
};

const resolve = value => (isFunction(value) ? value() : value);
function applyPreset(unresolvedPreset) {
  const preset = resolve(unresolvedPreset);
  const {
    url = [],
    variables = {},
  } = resolve(isString(preset) ? this[symbols.presets][preset] : preset);

  this[symbols.dom].Styles.setVariables(variables);

  return this[symbols.dom].Styles.load(url);
}

export default class UI {
  COLORS = 'colors';
  FONTS = 'fonts';

  constructor(domInstance) {
    this[symbols.dom] = domInstance;
    this[symbols.presets] = {};
  }

  async init(options = {}) {
    this[symbols.presets] = options.presets;

    if (options.autoApply) {
      await this.apply();
    }

    return this;
  }

  async apply(presets) {
    const toApply = presets || keys(this[symbols.presets]);

    if (!isArray(toApply)) {
      return this::applyPreset(toApply);
    }

    return Promise.all(toApply.map(this::applyPreset));
  }
}



// WEBPACK FOOTER //
// ./src/UI/UI.js